(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_bonus-gift"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__norvioBonusInit) return;
    window.__norvioBonusInit = true;

    var inFlight = false;
    var lastBonusAddAt = 0;

    function getActiveBonusBlock() {
      var blocks = document.querySelectorAll('.norvio-bonus[data-bonus-variant-id]');
      for (var i = 0; i < blocks.length; i++) {
        var b = blocks[i];
        var mode = b.dataset.bonusMode;
        if (mode === 'display') continue;
        if (mode === 'checkbox') {
          var cb = b.querySelector('.norvio-bonus__check-input');
          if (!cb || !cb.checked) continue;
        }
        return b;
      }
      return null;
    }

    function addBonusToCart() {
      if (inFlight) return;
      var now = Date.now();
      if (now - lastBonusAddAt < 800) return;

      var block = getActiveBonusBlock();
      if (!block) return;

      var variantId = block.dataset.bonusVariantId;
      if (!variantId) return;

      inFlight = true;

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var alreadyIn = cart.items.some(function (item) {
            return String(item.variant_id) === String(variantId);
          });
          if (alreadyIn) {
            inFlight = false;
            return null;
          }
          var body = new FormData();
          body.append('items[][id]', variantId);
          body.append('items[][quantity]', '1');
          body.append('items[][properties][_bonus_gift]', 'true');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: body
          });
        })
        .then(function (res) {
          inFlight = false;
          if (!res) return;
          lastBonusAddAt = Date.now();
        })
        .catch(function () { inFlight = false; });
    }

    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      var isCartAdd = urlStr.indexOf('/cart/add') > -1;
      var promise = origFetch.apply(this, arguments);
      if (isCartAdd) {
        promise.then(function (res) {
          try {
            var clone = res.clone();
            clone.json().then(function (body) {
              if (body && body.properties && body.properties._bonus_gift) return;
              addBonusToCart();
            }).catch(function () { addBonusToCart(); });
          } catch (e) { addBonusToCart(); }
        }).catch(function () {});
      }
      return promise;
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_complementary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('norvio-complementary')) {
      customElements.define('norvio-complementary', class extends HTMLElement {
        connectedCallback() {
          if (this.__nvInit) return;
          this.__nvInit = true;
          // Wait a frame so layout/styles are applied before measuring.
          requestAnimationFrame(() => this.init());
        }

        init() {
          this.track = this.querySelector('[id^="NvCompTrack-"]');
          this.prevBtn = this.querySelector('[data-nv-prev]');
          this.nextBtn = this.querySelector('[data-nv-next]');
          this.dotsWrap = this.querySelector('[data-nv-dots]');
          this.slides = Array.from(this.querySelectorAll('.nv-comp__slide'));
          if (!this.track || !this.slides.length) return;

          this.buildDots();
          this.bind();
          this.update();

          // Recheck overflow when fonts/images load or viewport changes.
          this._ro = new ResizeObserver(() => this.update());
          this._ro.observe(this.track);
          window.addEventListener('resize', this._onResize = () => this.update(), { passive: true });
        }

        get pageSize() {
          // How many whole slides fit in the viewport right now.
          const first = this.slides[0];
          if (!first) return 1;
          const slideW = first.getBoundingClientRect().width;
          const styles = getComputedStyle(this.track);
          const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
          const step = slideW + gap;
          if (!step) return 1;
          return Math.max(1, Math.round(this.track.clientWidth / step));
        }

        get pageCount() {
          const per = this.pageSize;
          return Math.max(1, Math.ceil(this.slides.length / per));
        }

        buildDots() {
          this.dotsWrap.innerHTML = '';
          this.dots = [];
          const pages = this.pageCount;
          for (let i = 0; i < pages; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'nv-comp__dot' + (i === 0 ? ' is-active' : '');
            b.setAttribute('aria-label', 'Slide ' + (i + 1));
            b.addEventListener('click', () => this.goToPage(i));
            this.dotsWrap.appendChild(b);
            this.dots.push(b);
          }
        }

        bind() {
          this.prevBtn && this.prevBtn.addEventListener('click', () => this.move(-1));
          this.nextBtn && this.nextBtn.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => {
            window.clearTimeout(this._st);
            this._st = window.setTimeout(() => this.update(), 90);
          }, { passive: true });
        }

        currentPage() {
          const per = this.pageSize;
          const first = this.slides[0];
          if (!first) return 0;
          const slideW = first.getBoundingClientRect().width;
          const styles = getComputedStyle(this.track);
          const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
          const step = (slideW + gap) * per;
          if (!step) return 0;
          return Math.round(this.track.scrollLeft / step);
        }

        goToPage(i) {
          const per = this.pageSize;
          const target = this.slides[Math.min(i * per, this.slides.length - 1)];
          if (target) {
            this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          }
        }

        move(dir) {
          this.goToPage(this.currentPage() + dir);
        }

        update() {
          // Rebuild dots if page count changed (e.g. viewport resized).
          if (!this.dots || this.dots.length !== this.pageCount) this.buildDots();

          const hasOverflow = this.track.scrollWidth - this.track.clientWidth > 2;
          this.classList.toggle('nv-comp--has-overflow', hasOverflow);

          const max = this.track.scrollWidth - this.track.clientWidth;
          const x = this.track.scrollLeft;
          if (this.prevBtn) this.prevBtn.disabled = x <= 2;
          if (this.nextBtn) this.nextBtn.disabled = x >= max - 2;

          const active = this.currentPage();
          this.dots && this.dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
        }

        disconnectedCallback() {
          this._ro && this._ro.disconnect();
          this._onResize && window.removeEventListener('resize', this._onResize);
        }
      });
    }
  } catch(e) { console.error(e); }
})();

})();
